import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { System } from "../commons/Constants";

export const ROLLER_ADS_BACKFILL_TYPE_TAG = "PW_ROLLER_ADS_BACKFILL";

export function useRollerAdsBackfill() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();

  const isParkWeb = landerConfig.system === System.PARKWEB;
  const canOwnTypeTag = isParkWeb && !landerConfig.experiment?.key;

  useEffect(() => {
    if (!canOwnTypeTag) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_YAHOO_TYPE_TAG,
      payload: {
        typeTag: ROLLER_ADS_BACKFILL_TYPE_TAG,
      },
    });
  }, [canOwnTypeTag, landerConfigDispatch]);

  return { isBackfillEligible: isParkWeb };
}
